import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const BeforePublicationsList = () => {
  const [publications, setPublications] = useState([]);
  const [filteredPublications, setFilteredPublications] = useState([]);
  const [statusFilter, setStatusFilter] = useState('All');
  const history = useHistory();

  const userId = sessionStorage.getItem('userId');
 

  useEffect(() => {
    const fetchPublications = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/by-department/${userId}`);
        setPublications(response.data);
        setFilteredPublications(response.data); // Initially show all
      } catch (error) {
        console.error('Error fetching publications:', error);
      }
    };

    fetchPublications();
  }, [userId]);

  const getStatusText = (status) => {
    if (status === '1') return 'Approved';
    if (status === '2') return 'Rejected';
    return 'Not Approved';
  };

  const handleView = (id) => {
    history.push(`/beforepublication/view/${id}`);
  };

  const handleFilterChange = (e) => {
    const selected = e.target.value;
    setStatusFilter(selected);

    if (selected === 'All') {
      setFilteredPublications(publications);
    } else {
      const statusMap = {
        Approved: '1',
        Rejected: '2',
        'Not Approved': '0',
      };
      const filtered = publications.filter(pub => pub.status === statusMap[selected]);
      setFilteredPublications(filtered);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="text-primary">Before Publications</h3>
        <select
          className="form-select w-auto"
          value={statusFilter}
          onChange={handleFilterChange}
        >
          <option value="All">All</option>
          <option value="Approved">Approved</option>
          <option value="Rejected">Rejected</option>
          <option value="Not Approved">Not Approved</option>
        </select>
      </div>

      <table className="table table-bordered table-hover">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Paper Title</th>
            <th>Journal</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredPublications.length > 0 ? (
            filteredPublications.map((pub) => (
              <tr key={pub.id}>
                <td>{pub.id}</td>
                <td>{pub.paperTitle}</td>
                <td>{pub.journalName}</td>
                <td className={
    pub.status === '1' ? 'text-success' :
    pub.status === '2' ? 'text-danger' :
    'text-warning'
  }>{getStatusText(pub.status)}</td>
                <td>
                  <button className="btn btn-sm btn-info" onClick={() => handleView(pub.id)}>View</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">No publications found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BeforePublicationsList;
